import AboutUsForm from "../components/layout/about-us/AboutUsForm";

const AboutUsPage = (props) => {
  return (
    <AboutUsForm content={props.content} socialMedia={props.socialMedia} />
  );
};

export default AboutUsPage;
